import { render, staticRenderFns } from "./onlineFormLogin.vue?vue&type=template&id=366630b2&"
import script from "./onlineFormLogin.vue?vue&type=script&lang=js&"
export * from "./onlineFormLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports